<template>
    <div id="EnHomeBanner">
        <div class="video-container">
            <video v-if="isMobile" autoplay muted loop playsInline>
                <source type="video/mp4" :src="require('@/assets/video/video_compressed_muted_480p.mp4')" />
                <source type="video/webm" :src="require('@/assets/video/video_compressed_muted_480p.webm')" />
            </video>
            <video v-else autoplay muted loop playsInline>
                <source type="video/webm" :src="require('@/assets/video/video_compressed_muted.webm')" />
                <source type="video/mp4" :src="require('@/assets/video/video_compressed_muted.mp4')" />
            </video>
        </div>
        <h2 class="home-banner-title f24 f12-mb lh18">
            Marine debris threatens both the existence of marine life and the marine environment <br />
            Taiwan has the technology and ability to recycle and reuse marine debris<br />
            The entire nation joins the line of protecting the ocean and contribute to the earth’s overall wellbeing
        </h2>
        <ul class="home-banner-button w2 w90-mb">
            <li v-for="item of bannerButtonList" :key="'banner-button-' + item.icon">
                <router-link v-if="item.routeUrl" :to="item.routeUrl">
                    <i class="f48 f24-mb lh15" :class="'icon-' + item.icon"></i>
                    <p class="f20 f16-mb bold lh15">{{ item.title }}</p>
                </router-link>
                <a v-else-if="item.href" :href="item.href" target="_blank">
                    <i class="f48 f24-mb lh15" :class="'icon-' + item.icon"></i>
                    <p class="f20 f16-mb bold lh15">{{ item.title }}</p>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
import { computed } from 'vue'
export default {
    name: 'EnHomeBanner',
    setup() {
        const isMobile = computed(() => window.innerWidth < 768)
        // banner 按鈕資料
        const bannerButtonList = [
            {
                icon: 'statistics',
                title: 'Statistics of marine debris',
                routeUrl: { name: 'EnStatistics' },
            },
            {
                icon: 'clean',
                title: 'Join a beach cleanup',
                href: 'https://ecolife2.moenv.gov.tw/coastal/SeaCalendar/SeaCalendar',
            },
            {
                icon: 'cycle',
                title: 'Recycling supply chain',
                routeUrl: { name: 'EnSupplyChainIntro' },
            },
            {
                icon: 'badge',
                title: 'Recycled marine debris product label',
                routeUrl: { name: 'EnCycleBadgeIntro' },
            },
        ]

        return { isMobile, bannerButtonList }
    },
}
</script>
<style lang="scss" scoped>
#EnHomeBanner {
    position: relative;
    background-color: $theme0;
    padding-bottom: 30px;
}
.video-container {
    position: absolute;
    left: 0;
    top: 0;

    width: 100%;
    overflow: hidden;
    &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, rgba($black, 0.2), rgba($black, 0.6));
    }
    video {
        position: relative;
        width: 100%;
    }
    @media screen and (min-width: 1200px) {
        height: 500px;
        video {
            top: calc(250px - 56%);
        }
    }
    @media screen and (max-width: 1199px) and (min-width: 768px) {
        height: 400px;
        video {
            top: calc(200px - 56%);
        }
    }
    @media screen and (max-width: 767px) {
        height: 200px;
    }
}
.home-banner-title {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $white;
    text-align: center;
    padding: 0 20px;
    @media screen and (min-width: 1200px) {
        height: 400px;
    }
    @media screen and (max-width: 1199px) and (min-width: 768px) {
        height: 300px;
    }
    @media screen and (max-width: 767px) {
        height: 160px;
    }
}
.home-banner-button {
    position: relative;
    display: flex;
    li {
        text-align: center;
        background-color: $white;
        box-shadow: $shadow2;

        i {
            display: block;
            color: $theme3;
        }
        p {
            color: $theme4;
        }
    }
    @media screen and (min-width: 1200px) {
        li {
            margin: 15px;
            padding: 20px;
            flex: 1 1 20%;
        }
    }
    @media screen and (max-width: 1199px) and (min-width: 768px) {
        flex-wrap: wrap;
        li {
            margin: 5px;
            padding: 15px;
            flex: 1 1 33%;
        }
    }
    @media screen and (max-width: 767px) {
        flex-wrap: wrap;
        li {
            margin: 5px;
            padding: 15px 10px;
            flex: 1 1 25%;
        }
    }
}
</style>
